import { createContext } from "react";

const spinnerContext = createContext(null);

export default spinnerContext;